<div class="qr-card" [ngStyle]="{ 'font-family': font }">
  <div class="qr-card__body">
    <div class="qr-card__header">
      <div class="qr-card__header__left">
        <div class="qr-card__header__table">TABLE</div>
        <p class="qr-card__order-location">{{ locationNumber() }}</p>
      </div>
      <div class="qr-card__code__img" #QRCanvas [ngStyle]="{ 'background-color': themeColor() || defaultThemeColor }"></div>
      <div class="qr-card__store-logo">
        @if (storeLogo(); as logoUrl) {
          <img class="qr-card__store-logo" [src]="logoUrl" alt="Store logo" />
        }
      </div>
    </div>
    <div class="qr-card__content">
      @if (!isDetailsPage()) {
        <p class="qr-card__content__heading">Scan, Order & Pay</p>
        @if (hasBackPage()) {
          <p class="qr-card__content__text">See back for details</p>
        }
      } @else {
        <ul class="qr-card__points">
          @for (detailPoint of detailPoints; track $index) {
            <li class="qr-card__point">
              <div class="qr-card__point__number" [ngStyle]="{ 'background-color': themeColor() || defaultThemeColor }">
                {{ $index + 1 }}
              </div>
              <h3 class="qr-card__point__text">{{ detailPoint }}</h3>
            </li>
          }
        </ul>
      }
    </div>
  </div>
  <div class="qr-card__footer">
    <p>Powered by</p>
    <img class="qr-card__footer__logo" src="../../../../../assets/images/kp-footer-logo.svg" alt="Kody logo" />
  </div>
</div>
